import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { useQuery } from "@tanstack/react-query";
import { odataFetch } from "../../lib/odata-fetch";
import { Defect, NonConformance } from "../../odata/appu4dm/AppU4DMModel";
import { qNonConformance, QNonConformance } from "../../odata/appu4dm/QAppU4DM";
import { ncKeys } from "./nc-keys";

export function useNC(nId: string) {
  const { data, ...query } = useQuery({
    queryKey: ncKeys.getNc(nId),
    queryFn: ({ meta }) => fetchNC(nId, meta!.token!),
    enabled: ({ meta }) => !!meta?.token,
  });

  return {
    nc: data?.value?.[0],
    ...query,
  };
}

type DefectsResponse = Pick<Defect, "FailureNId">;

export async function fetchNC(nId: string, token: string) {
  const builder = createQueryBuilderV4("NonConformance", new QNonConformance())
    .filter(qNonConformance.NId.eq(nId))
    .select("Id", "Status")
    .expanding("Defects", (b) => b.select("FailureNId"));

  return odataFetch<
    Pick<NonConformance, "Id" | "Status"> & { Defects: DefectsResponse[] }
  >({
    token,
    builder,
  });
}
